import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  BulkPreviewArrearsRequestInput,
  PayrollBulkPreviewArrearsGraphQLRequest,
  PayrollBulkPreviewArrearsResponse,
} from '../types';

const payrollBulkPreviewArrearsMutation = gql`
  mutation PayrollBulkPreviewArrears($input: BulkPreviewArrearsRequestInput!) {
    payrollBulkPreviewArrears(input: $input) {
      code
      success
      message
      data {
        requestId
        arrears {
          id
          merchantId
          tenantId
          userId
          sourceMonth
          arrearCause
          targetPayrollMonth
          arrearDays
          rlopDays
          arrearComponents {
            id
            tenantId
            payrollArrearId
            componentName
            sdiType
            formulae
            isAmountFixed
            includeInPayroll
            includeInCompensation
            createdAt
            updatedAt
            deletedAt
          }
          createdAt
          updatedAt
          deletedAt
        }
        errors
      }
    }
  }
`;

export const bulkPreviewArrears = (input: BulkPreviewArrearsRequestInput) => {
  return graphQLApi<PayrollBulkPreviewArrearsResponse, PayrollBulkPreviewArrearsGraphQLRequest>({
    query: payrollBulkPreviewArrearsMutation,
    queryVariables: { input },
  });
};

